// extracted by mini-css-extract-plugin
module.exports = {"typingText":"ExpertTyping_typingText__3Ar0Z","jumpingDots":"ExpertTyping_jumpingDots__3ptD3"};